import '@babel/polyfill';
import 'angular-loading-bar/build/loading-bar.css';
import 'portal/../content/styles/app.scss';
import 'ui-select/dist/select.css';

import './app.scss';
import './cart.scss';
import './thanks.scss';
import './vendor';

import * as _ from 'lodash';
import * as angular from 'angular';
import * as uiRouter from 'angular-ui-router';
import * as uiSelect from 'ui-select';

import checkoutModule from './checkout';
import commonModule from './common';
import productModule from './product';
import shellModule from './shell';
import { IWindowService } from 'angular';

export default angular.module('fp:customerportal:shop', [
    uiRouter,
    uiSelect,

    commonModule.name,
    shellModule.name,
    productModule.name,
    checkoutModule.name
])
    .run(/*@ngInject*/ ($log: ng.ILogService, templateData: any) => {
        $log.debug('Current Template: ' + templateData.template + '.liquid');
    })

    .run(/*@ngInject*/($log: ng.ILogService, $rootScope: ng.IRootScopeService) => {
        $rootScope.$on('storefrontError', (e: ng.IAngularEvent, data: any) => {
            $log.error(data.title);
            $log.error(data.message);
        });
    })

    .run(/*@ngInject*/($rootScope: IShopRootScope, dataContext: any, $window: IWindowService) => {
        dataContext.emergency.getMonitoringAdcInfo().then((result: any) => {
            dataContext.account.getCustomerInformationV2().then((accountResult: any) => {
                dataContext.account.AccessCheckForOrlandoAccount().then((accessResult: any) => {
                    if (!accessResult) {
                        $window.open('/accessCheck', '_self');
                    }
                    if (result.WbServicePlanName === 'Video Only') {
                        $window.open('/videoonly', '_self');
                    } else if (accountResult.CustomerInformation.HasProductExclusiveLeadSource === true) {
                        $window.open('/jci', '_self');
                    } else {
                        const token = dataContext.user.initialize();
                        $rootScope.isAuthenticated = !_.isEmpty(token);
                        if (!$rootScope.isAuthenticated) {
                            $rootScope.$broadcast('event:auth-loginRequired', {});
                        }
                    }
                });
            });
        });
    });
